import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { FeatureFlags } from '@rd/types/feature-flag.type';
import { FeatureFlagService } from '../../services/feature-flag/feature-flag.service';

@Injectable()
export class ShoppingCartFeatureGuard implements CanActivate {
  constructor(
    private router: Router,
    private featureFlagService: FeatureFlagService,
  ) {}

  canActivate(): boolean {
    if (this.featureFlagService.isEnable(FeatureFlags.ShoppingCart)) {
      return true;
    }

    this.router.navigateByUrl('/not-found');
    return false;
  }
}
